type SecurityQuestionAnswer = {
  question: string;
  answer: string;
};

export type CreateAccountState = {
  email: string;
  first: string;
  last: string;
  suffix?: string;
  password: string;
  confirm: string;
  security: {
    '1': SecurityQuestionAnswer;
    '2': SecurityQuestionAnswer;
    '3': SecurityQuestionAnswer;
  };
};

type UpdateSecurityQuestionAction = {
  type: 'updateSecurityQuestion';
  payload: {
    question: string;
    num: '1' | '2' | '3';
  };
};

type UpdateSecurityAnswerAction = {
  type: 'updateSecurityAnswer';
  payload: {
    answer: string;
    num: '1' | '2' | '3';
  };
};

type ResetAction = { type: 'reset' };

type SetStateAction = {
  type: 'setState';
  payload: Partial<CreateAccountState>;
};

type CreateAccountAction =
  | ResetAction
  | SetStateAction
  | UpdateSecurityQuestionAction
  | UpdateSecurityAnswerAction;

export function init(): CreateAccountState {
  const securityDefault: SecurityQuestionAnswer = {
    question: '',
    answer: '',
  };
  return {
    email: '',
    first: '',
    last: '',
    suffix: undefined,
    password: '',
    confirm: '',
    security: {
      '1': securityDefault,
      '2': securityDefault,
      '3': securityDefault,
    },
  };
}

function reducer(state: CreateAccountState, action: CreateAccountAction) {
  switch (action.type) {
    case 'updateSecurityQuestion':
      const { question, num } = action.payload;
      return {
        ...state,
        security: {
          ...state.security,
          [num]: { question: question, answer: '' },
        },
      };
    case 'updateSecurityAnswer': {
      const { answer, num } = action.payload;
      return {
        ...state,
        security: {
          ...state.security,
          [num]: { ...state.security[num], answer },
        },
      };
    }
    case 'setState': {
      return { ...state, ...action.payload };
    }
    case 'reset': {
      return init();
    }
  }
}

export default reducer;
